var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('section', {
    attrs: {
      "id": "statistics-cards"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_vm.clients ? _c('div', {
    staticClass: "col-xl-3 col-md-4 col-sm-6 mb-1"
  }, [_c('b-card', {
    staticClass: "h-100",
    attrs: {
      "no-body": ""
    }
  }, [_c('b-card-body', {
    staticClass: "d-flex flex-column justify-content-center align-items-center h-100"
  }, [_c('feather-icon', {
    staticClass: "mb-2",
    attrs: {
      "icon": "UsersIcon",
      "size": "40"
    }
  }), _c('h2', {
    staticClass: "font-weight-bolder mb-0"
  }, [_vm._v(_vm._s(_vm.clients.total))]), _c('p', {
    staticClass: "card-text"
  }, [_vm._v("Total Clients")])], 1)], 1)], 1) : _vm._e(), _vm.clients ? _c('div', {
    staticClass: "col-xl-3 col-md-4 col-sm-6 mb-1"
  }, [_c('b-card', {
    staticClass: "h-100",
    attrs: {
      "no-body": ""
    }
  }, [_c('b-card-body', {
    staticClass: "text-center d-flex flex-column justify-content-center align-items-center h-100"
  }, [_c('feather-icon', {
    staticClass: "mb-2",
    attrs: {
      "icon": "UserPlusIcon",
      "size": "40"
    }
  }), _c('h2', {
    staticClass: "font-weight-bolder mb-0"
  }, [_vm._v(_vm._s(_vm.clients.new_this_month))]), _c('p', {
    staticClass: "card-text"
  }, [_vm._v("New This Month")])], 1)], 1)], 1) : _vm._e(), _vm.clients ? _c('div', {
    staticClass: "col-xl-3 col-md-4 col-sm-6 mb-1"
  }, [_c('b-card', {
    staticClass: "h-100",
    attrs: {
      "no-body": ""
    }
  }, [_c('b-card-body', {
    staticClass: "text-center d-flex flex-column justify-content-center align-items-center h-100"
  }, [_c('feather-icon', {
    staticClass: "mb-2",
    attrs: {
      "icon": "BriefcaseIcon",
      "size": "40"
    }
  }), _c('h2', {
    staticClass: "font-weight-bolder mb-0"
  }, [_vm._v(_vm._s(_vm.clients.churn_rate))]), _c('p', {
    staticClass: "card-text"
  }, [_vm._v("Paid Client")])], 1)], 1)], 1) : _vm._e(), _vm.clients ? _c('div', {
    staticClass: "col-xl-3 col-md-4 col-sm-6 mb-1"
  }, [_c('b-card', {
    staticClass: "h-100",
    attrs: {
      "no-body": ""
    }
  }, [_c('b-card-body', {
    staticClass: "text-center d-flex flex-column justify-content-center align-items-center h-100"
  }, [_c('feather-icon', {
    staticClass: "mb-2",
    attrs: {
      "icon": "UserCheckIcon",
      "size": "40"
    }
  }), _c('h2', {
    staticClass: "font-weight-bolder mb-0"
  }, [_vm._v(_vm._s(_vm.clients.trial))]), _c('p', {
    staticClass: "card-text"
  }, [_vm._v("Trial Clients")])], 1)], 1)], 1) : _vm._e()])]), _c('section', {
    staticClass: "mt-4",
    attrs: {
      "id": "statistics-cards"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_vm.clients ? _c('div', {
    staticClass: "col-xl-3 col-md-4 col-sm-6 mb-4"
  }, [_c('b-card', {
    staticClass: "h-100",
    attrs: {
      "no-body": ""
    }
  }, [_c('b-card-body', {
    staticClass: "text-center d-flex flex-column justify-content-center align-items-center h-100"
  }, [_c('feather-icon', {
    staticClass: "mb-2",
    attrs: {
      "icon": "UserCheckIcon",
      "size": "40"
    }
  }), _c('h2', {
    staticClass: "font-weight-bolder mb-0"
  }, [_vm._v(_vm._s(_vm.clients.active))]), _c('p', {
    staticClass: "card-text"
  }, [_vm._v("Active Clients")])], 1)], 1)], 1) : _vm._e(), _vm.clients ? _c('div', {
    staticClass: "col-xl-3 col-md-4 col-sm-6 mb-4"
  }, [_c('b-card', {
    staticClass: "h-100",
    attrs: {
      "no-body": ""
    }
  }, [_c('b-card-body', {
    staticClass: "text-center d-flex flex-column justify-content-center align-items-center h-100"
  }, [_c('feather-icon', {
    staticClass: "mb-2",
    attrs: {
      "icon": "UserXIcon",
      "size": "40"
    }
  }), _c('h2', {
    staticClass: "font-weight-bolder mb-0"
  }, [_vm._v(_vm._s(_vm.clients.cancelled))]), _c('p', {
    staticClass: "card-text"
  }, [_vm._v("Cancelled Clients")])], 1)], 1)], 1) : _vm._e(), _vm.localTotals ? _c('div', {
    staticClass: "col-xl-3 col-md-4 col-sm-6 mb-4"
  }, [_c('b-card', {
    staticClass: "h-100",
    attrs: {
      "no-body": ""
    }
  }, [_c('b-card-body', {
    staticClass: "text-center d-flex flex-column justify-content-center align-items-center h-100"
  }, [_c('feather-icon', {
    staticClass: "mb-2",
    attrs: {
      "icon": "CreditCardIcon",
      "size": "40"
    }
  }), _c('h2', {
    staticClass: "font-weight-bolder mb-0"
  }, [_vm._v(" " + _vm._s(_vm.localTotals.mrr) + " / " + _vm._s(_vm.localTotals.arr) + " ")]), _c('p', {
    staticClass: "card-text"
  }, [_vm._v("Payments (MRR / ARR)")])], 1)], 1)], 1) : _vm._e(), _vm.localTotals ? _c('div', {
    staticClass: "col-xl-3 col-md-4 col-sm-6 mb-4"
  }, [_c('b-card', {
    staticClass: "h-100",
    attrs: {
      "no-body": ""
    }
  }, [_c('b-card-body', {
    staticClass: "text-center d-flex flex-column justify-content-center align-items-center h-100"
  }, [_c('feather-icon', {
    staticClass: "mb-2",
    attrs: {
      "icon": "CalendarIcon",
      "size": "40"
    }
  }), _c('h2', {
    staticClass: "font-weight-bolder mb-0"
  }, [_vm._v(_vm._s(_vm.localTotals.upcoming_renewals))]), _c('p', {
    staticClass: "card-text"
  }, [_vm._v(" Upcoming Renewals "), _c('br'), _vm._v(" Expected Revenue: " + _vm._s(_vm.localTotals.upcoming_revenue) + " ")])], 1)], 1)], 1) : _vm._e()])]), _c('section', {
    staticClass: "mt-4"
  }, [_vm._m(0), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4 mb-10"
  }, [_c('b-tabs', {
    attrs: {
      "content-class": "mt-2"
    }
  }, [_c('b-tab', {
    attrs: {
      "title": "Packages",
      "active": ""
    }
  }, [_c('b-card', {
    attrs: {
      "no-body": ""
    }
  }, [_c('b-card-header', [_c('b-card-title', [_vm._v("Package Wise Client")])], 1), _c('b-card-body', [_c('canvas', {
    attrs: {
      "id": "planChart"
    }
  })])], 1)], 1)], 1)], 1), _c('div', {
    staticClass: "col-lg-8 mb-2"
  }, [_c('b-tabs', {
    attrs: {
      "content-class": "mt-2"
    }
  }, [_c('b-tab', {
    attrs: {
      "title": "Payments",
      "active": ""
    }
  }, [_c('b-card', {
    attrs: {
      "no-body": ""
    }
  }, [_c('b-card-header', [_c('b-card-title', [_vm._v("Payment Breakdown")])], 1), _c('b-card-body', [_c('b-table', {
    attrs: {
      "items": _vm.paymentMethods,
      "fields": _vm.paymentFields,
      "striped": "",
      "hover": ""
    }
  })], 1)], 1)], 1), _c('b-tab', {
    attrs: {
      "title": "Top Companies"
    }
  }, [_c('b-card', {
    attrs: {
      "no-body": ""
    }
  }, [_c('b-card-header', [_c('b-card-title', [_vm._v("Top Paying Companies")])], 1), _c('b-card-body', [_c('b-table', {
    attrs: {
      "items": _vm.topCompanies,
      "fields": _vm.topCompanyFields,
      "striped": "",
      "hover": ""
    }
  })], 1)], 1)], 1), _c('b-tab', {
    attrs: {
      "title": "Package & Payment Wise Clients"
    }
  }, [_c('b-card', {
    attrs: {
      "no-body": ""
    }
  }, [_c('b-card-header', [_c('b-card-title', [_vm._v("Package & Payment Method Wise Clients")])], 1), _c('b-card-body', [_c('b-table', {
    attrs: {
      "items": _vm.paymentPackageWiseClients,
      "fields": _vm.paymentPackageFields,
      "striped": "",
      "hover": ""
    }
  })], 1)], 1)], 1)], 1)], 1)])]), _c('section', {
    staticClass: "mt-4"
  })]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6 mb-3"
  }, [_c('div', {
    staticClass: "card shadow-sm"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("MRR Growth (Last 6 Months)")]), _c('div', {
    staticClass: "card-body"
  }, [_c('canvas', {
    attrs: {
      "id": "mrrChart"
    }
  })])])]), _c('div', {
    staticClass: "col-lg-6 mb-3"
  }, [_c('div', {
    staticClass: "card shadow-sm"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("Churn vs New Clients")]), _c('div', {
    staticClass: "card-body"
  }, [_c('canvas', {
    attrs: {
      "id": "churnChart"
    }
  })])])])]);
}]

export { render, staticRenderFns }